import {Injectable} from '@angular/core';
import {
  CrudService,
  JsonApiParams,
  JsonApiResponse,
  deserialize,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireStaffRole} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';

@Injectable()
export class StaffRolesService implements CrudService<UmpireStaffRole> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireStaffRole[]>> {
    return this.http
      .get(`/staff_roles`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/staff_roles/${id}`);
  }

  create(
    body: Partial<UmpireStaffRole>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireStaffRole>> {
    return this.http
      .post<JsonApiResponse<UmpireStaffRole>>('/staff_roles', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireStaffRole>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireStaffRole>> {
    return this.http
      .patch<JsonApiResponse<UmpireStaffRole>>(
        `/staff_roles/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
